import { createFileRoute, useParams } from '@tanstack/react-router';
import { z } from 'zod';

import { ErrorComponent } from '@/components/common/ErrorComponent';
import { useSetBreadcrumbs } from '@/components/layout/breadcrumbs';

import { CounterTableDetail } from './-components/CounterTableDetail';

const searchSchema = z.object({
  lang: z.string().optional(),
  q: z.string().optional(),
  missingOnly: z.boolean().optional(),
});

function CounterDetailRoute() {
  const { key } = useParams({ from: '/counters/$key' });
  useSetBreadcrumbs([
    { label: 'Workspace' },
    { label: 'Counters', to: '/counters' },
    { label: key },
  ]);
  return <CounterTableDetail tableKey={key} />;
}

export const Route = createFileRoute('/counters/$key')({
  validateSearch: searchSchema,
  component: CounterDetailRoute,
  errorComponent: ErrorComponent,
});
